import { StorageService } from './shared/common/services/storage.service';

export function clearScreenLocksFactory(storageService: StorageService) {
  return () => {
    storageService.removeScreenLocks();
    return Promise.resolve();
  };
}
